var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImageUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 32.5676V22.3514C51 19.3408 49.8041 16.4535 47.6753 14.3247C45.5465 12.1959 42.6592 11 39.6486 11H20.3514C17.3408 11 14.4535 12.1959 12.3247 14.3247C10.1959 16.4535 9 19.3408 9 22.3514V38.2432C9 39.7339 9.29361 41.21 9.86407 42.5872C10.4345 43.9644 11.2707 45.2158 12.3247 46.2699C14.4535 48.3986 17.3408 49.5946 20.3514 49.5946H34.5632",
    stroke: "#C46070",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59027 41.6486L15.8108 34.3838C16.6277 33.5724 17.6999 33.0682 18.8459 32.9565C19.9919 32.8448 21.1412 33.1325 22.0995 33.7708C23.0577 34.4091 24.2071 34.6968 25.353 34.5851C26.499 34.4734 27.5712 33.9692 28.3881 33.1578L33.6778 27.8681C35.1978 26.343 37.2101 25.4076 39.3559 25.2288C41.5016 25.05 43.641 25.6394 45.3924 26.8919L51 31.2281M20.9416 26.1427C21.4365 26.1397 21.926 26.0393 22.3821 25.8471C22.8382 25.655 23.252 25.3749 23.5998 25.0228C23.9477 24.6708 24.2227 24.2536 24.4094 23.7953C24.596 23.3369 24.6905 22.8463 24.6876 22.3513C24.6846 21.8564 24.5842 21.367 24.392 20.9109C24.1999 20.4548 23.9198 20.041 23.5677 19.6932C23.2156 19.3453 22.7985 19.0702 22.3401 18.8836C21.8818 18.6969 21.3911 18.6024 20.8962 18.6054C19.8967 18.6114 18.9405 19.0142 18.238 19.7253C17.5355 20.4363 17.1443 21.3972 17.1503 22.3968C17.1563 23.3963 17.5591 24.3524 18.2701 25.0549C18.9812 25.7574 19.9421 26.1487 20.9416 26.1427Z",
    stroke: "#C46070",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2267 37.1081V48.4595",
    stroke: "#C46070",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4324 41.887L45.9668 37.4214C45.8698 37.3239 45.7544 37.2466 45.6274 37.1938C45.5004 37.141 45.3642 37.1139 45.2267 37.1139C45.0892 37.1139 44.953 37.141 44.826 37.1938C44.699 37.2466 44.5836 37.3239 44.4866 37.4214L40.021 41.887",
    stroke: "#C46070",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImageUpload);
export default __webpack_public_path__ + "static/media/icon-image-upload.ab45f8f5867b93b1467384bbe7abf3ae.svg";
export { ForwardRef as ReactComponent };